import classNames from "classnames";
import React from "react";

interface MenuDividerProps {
  className?: string;
  title?: string;
}

const MenuDivider = ({ className, title }: MenuDividerProps) => {
  return (
    <>
      <li
        className={classNames({
          className: className,
          "menu-divider": !title,
          "menu-header": title,
        })}
      >
        {title && <h6>{title}</h6>}
      </li>
    </>
  );
};

export default MenuDivider;

